import Base from 'src/storage/base';

import { CookiePolicy } from './CookiePolicy';
import { SlideMedia } from './SlideMedia';
import MobileAppsPopup from './mobileApps';
import { permissions } from 'src/helpers';
import CropImage from './CropImage';

class PopupModel extends Base {
  id = 'PopupModel';
  defaultState = () => ({ popups: [] });

  apiConfig = {};
  router = {};

  _events = {
    openSlideMedia: 'onOpenSlideMedia',
    openApp: 'onOpenApp',
    logout: 'onLogout',
    test_logout: 'onLogout',
    changeRouter: 'onChangeRouter'
  };

  onLogout = () => {
    let popups = this.state.popups.map((item) => {
      return {
        ...item,
        active: item.requireAuth ? false : item.active,
        allow: item.requireAuth ? false : item.allow
      };
    });
    this.log('onLogout', popups);
    this.setState({ popups });
    this.view?.sync();
  };

  activePopupDefault = () => ({ allow: false });

  setActivePopup = (id, activePopup) => {
    activePopup.id = id;
    activePopup.time = activePopup.time || Date.now();

    this.checkActiveByRouter(activePopup);

    let index = this.state.popups.findIndex((item) => item.id === id);

    if (index > -1) {
      let existing = this.state.popups[index];
      if (existing.active && activePopup.active && existing.allow) {
        activePopup.allow = true;
      }
      this.state.popups[index] = activePopup;
    } else {
      this.state.popups.push(activePopup);
    }

    this.setState({ popups: [...this.state.popups] });

    this.emit('onChangePopup', activePopup);
  };

  getActivePopup = (id = null) => {
    if (id) {
      return this.state.popups.find((item) => item.id === id) || this.activePopupDefault();
    }
    return this.state.popups.filter((item) => item.active);
  };

  openCookiePolicy = (actions) => {
    this.setActivePopup('cookie_policy', {
      active: true,
      time: Date.now() + 10000,
      component: CookiePolicy,
      props: { actions },
      noHideOutSide: true
    });
  };

  onOpenSlideMedia = ({ media, selectedIndex, onViewEdit, onSlide }) => {
    this.setActivePopup('slide_media', {
      active: true,
      component: SlideMedia,
      props: {
        media,
        selectedIndex,
        onViewEdit,
        onSlide
      }
    });
  };

  onOpenApp = (data) => {
    this.setActivePopup('open_app', {
      activeByRouter: ({ location }) => {
        const match = permissions.findMatchPath(location.pathname);
        if (!match) return true;
        return match.webType !== 'admin' && !match.isAuthPage;
      },
      component: MobileAppsPopup,
      showAlone: true,
      props: { data }
    });
  };

  onChangeRouter = (router) => {
    this.router = router;

    this.state.popups.forEach((item) => {
      if (this.checkActiveByRouter(item)) {
        this.emit('onChangePopup', item);
      }
    });
  };

  checkActiveByRouter = (activePopup) => {
    const { location } = this.router || {};
    if (!activePopup.active && !!activePopup.activeByRouter && location) {
      activePopup.active = activePopup.activeByRouter(this.router);
      if (activePopup.active) {
        activePopup.activeByRouter = null;
        activePopup.allow = true;
      }

      return true;
    }

    return false;
  };

  openCropImage = (props) => {
    this.setActivePopup('open_crop_image', {
      active: true,
      component: CropImage,
      props
    });
  };
}

const popup = new PopupModel();
export default popup;
